import "./label_list.js";

(function ($) {
  window.LabelSelector = function (container, labelsJSON) {
    container = jQuery(container);
    var context = this;
    var labelSelectedEvent = "labelSelected";
    var labelSelector = ".label";
    var filter = container.find("[name=filter]");
    var emptyMessage = container.find(".no-labels-message");
    var listContainer = container.find(".label-list");
    var labelList = new window.LabelList(listContainer);

    // BEHAVIOUR

    filter.on("input change", filterLabels);
    filter.on("keydown", selectLabelIfEnter);
    container.on("change click", labelSelector, normalizeLabelSelectedEvent);

    // INITIALIZE

    populateLabelsList(labelsJSON);

    // EVENT HANDLERS

    // Templates containing a label with an input to track selected state fires 2 click events, watch for change instead
    function normalizeLabelSelectedEvent(event) {
      var type = containsLabelWithInput(this) ? "change" : "click";
      if (event.type == type) {
        triggerLabelSelected(this);
        clearFilter();
      }
    }

    function selectLabelIfEnter(event) {
      if (event.which === 13) {
        if (readFilter()) {
          triggerLabelSelected(container.find(labelSelector).filter(":visible").first());
          clearFilter();
        }
        return false;
      }
    }

    // HELPER FUNCTIONS

    function toggleLabel(labelJSON) {
      var checkBox = container.find("[data-label-id=" + labelJSON.id + '] input[type="checkbox"]');
      checkBox.prop("checked", !checkBox.prop("checked"));
    }

    function addLabel(labelJSON) {
      listContainer.show();
      emptyMessage.hide();
      return labelList.addLabel(labelJSON);
    }

    function filterLabels() {
      var labels = container.find(labelSelector);
      var matching = readFilter() ? labels.filter(match) : labels;

      matching.show();
      labels.not(matching).hide();
    }

    function match() {
      return labelList.labelJSON(this).name.toLowerCase().indexOf(readFilter().toLowerCase()) > -1;
    }

    function containsLabelWithInput(label) {
      return jQuery(label).find("label input").length;
    }

    function triggerLabelSelected(label) {
      var labelJSON = labelList.labelJSON(label);
      jQuery(context).trigger(labelSelectedEvent, [labelJSON]);
      jQuery(label).trigger(labelSelectedEvent, [labelJSON]);
    }

    function readFilter() {
      return jQuery.trim(filter.val());
    }

    function clearFilter() {
      filter.val("");
      filterLabels();
    }

    function populateLabelsList(labelsJSON) {
      jQuery.each(labelsJSON, function () {
        addLabel(this);
      });
    }

    // PUBLIC INTERFACE

    jQuery.extend(this, {
      addLabel: addLabel,
      labels: labelList.labels,
      selectLabel: triggerLabelSelected,
      toggleLabel: toggleLabel,
    });
  };
})(jQuery);
